export default "__VITE_ASSET__OQ77QolrNDLE92gZt8d2Dw__"